import React, { useState, useEffect } from "react";
import Spinner from "../../utils/spinner/Spinner";
import { toast } from "react-toastify";
import { useSymbolContext } from "../../../contexts/Symbol-Context.js";
import {
  API_ENDPOINT_ORDER_DETAIL,
  API_ENDPOINT_UPDATE_ORDER_DETAIL,
} from "../../../data/Endpoints-API.js";
import APIMiddleware from "../../../data/api/Api-Middleware.js";
import { useAuthContext } from "../../../contexts/Auth-Context.js";
import { FaTimes } from "react-icons/fa";
import { formatPrice, formatFixedTrimmed } from "../../../utils/format.js";

import PendingOrderSLTP from "../market_order/PendingOrderSLTP.jsx";
import { useTranslation } from "react-i18next";

interface EditOrderProps {
  onCancel: () => void;
  editPositionId: any;
  currentPrice: any;
}

const EditOrderSltp: React.FC<EditOrderProps> = ({
  onCancel,
  editPositionId,
  currentPrice,
}) => {
  const { t } = useTranslation();
  //CONTEXT
  const { loadingSymbolContext, symbolData,setIsPositionEdited } = useSymbolContext();
  const { user,selectedAuthSymbol ,platFromData, isFirstLoginDisabled} = useAuthContext();
  // #region All states defined here States
  const [direction, setDirection] = useState(currentPrice.direction);
  const [tradeQuantity, setTradeQuantity] = useState(currentPrice.quantity);
  const [tradeEntryPrice, setTradeEntryPrice] = useState(0.0);
  const [takeProfit, setTakeProfit] = useState(0.0);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [stopLoss, setStopLoss] = useState(0.0);
  const [selectedSymbol, setSelectedSymbol] = useState({ask:0.0, bid:0.0})
  const [newEntryPrice, setNewEntryPrice] = useState(0.0)
  const [oldEntryPrice, setOldEntryPrice] = useState(0.0)

  //dragable dialogbox 
  const [position, setPosition] = useState({x:0, y:0});
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState({x:0, y:0});

  
  const handleMouseDown = (e)=>{
    setIsDragging(true);
    setDragOffset({
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    })
    console.log('its working');
    
  }

  const handleMouseMove =(e)=>{
    if(isDragging){
      setPosition({
        x: e.clientX -dragOffset.x,
        y: e.clientY -dragOffset.y,
      })
    }
  }

  const handleMouseUp = ()=>{
    setIsDragging(false)
  }


  const [selectedPosition, setSelectedPosition] = useState({
    SL: null,
    TP: null,
    order_id: "",
    direction: "",
    entry_price: "",
    symbol: "",
  });

  const [slPips, setSlPips] = useState(0.0);

  const handleDisabledButton = (data) => {
    setIsButtonDisabled(data)
  };

  const [tpPips, setTpPips] = useState(0.0);
  // SL: null, TP: null, position_id: '', direction: '', entry_price: ''

  // #endregion

  // #region All UseEffect defined here States

  useEffect(() => {
    if (editPositionId) {
      updateSelectedPosition(editPositionId);
    }
  }, [editPositionId]);

  // #region All functions defined here States
  useEffect(() => {
    setSelectedSymbol(symbolData[selectedPosition?.symbol])
  }, [editPositionId, selectedPosition?.symbol])
  
  useEffect(() => {

    setTradeEntryPrice((direction == "Buy" ? selectedSymbol?.bid: selectedSymbol?.ask));
  }, [selectedSymbol?.ask, selectedSymbol?.bid]);
  const handleProfitChange = (data) => {
    setTakeProfit(data);
  };
  const handleLossChange = (data) => {
    setStopLoss(data);
  };
  const handleSLPipsChange = (data) => {
    setSlPips(data)
  };


  const handleTPPipsChange = (data) => {
    setTpPips(data)
  };

  const updateSelectedPosition = async (p_id) => {
    try {
      if (user && user.userId !== undefined && user.userId > 0) {
        const response = await APIMiddleware.get(
          API_ENDPOINT_ORDER_DETAIL(user.userId, p_id)
        );
        if (response.data) {
          const positionDetails = response.data[0];
          console.log(positionDetails)
          setSelectedPosition(positionDetails);
          // Keep full precision for calculations
          setNewEntryPrice(formatFixedTrimmed(positionDetails.entry_price, 10));
          setOldEntryPrice(positionDetails.entry_price);
          setDirection(positionDetails.direction);
          setTradeQuantity(positionDetails.quantity);
        }
      }
    } catch (error) {
      // Handle API request error
      console.error(
        `API request error: ${API_ENDPOINT_ORDER_DETAIL}`,
        error
      );
    }
  };
 const entryPriceHandler = (e) => { 
  setNewEntryPrice(e.target.value)
  }
  const onSubmit = async () => {
    try {
      const entry = parseFloat(newEntryPrice);
      if (
        newEntryPrice === "" ||
        newEntryPrice == null ||
        isNaN(entry) ||
        entry <= 0
      ) {
        toast.error(t('editSltp.validEntryPrice'), {
          position: "top-right",
        });
        return;
      }

      setIsLoading(true);
      if (user && user.userId !== undefined && user.userId > 0) {
        const response = await APIMiddleware.post(
          API_ENDPOINT_UPDATE_ORDER_DETAIL(),
          {
            userId: user.userId,
            orderId: selectedPosition?.order_id,
            SL: stopLoss,
            TP: takeProfit,
            symbol: selectedPosition.symbol,
            quantity:tradeQuantity,
            entry_price: newEntryPrice,
            direction: direction,
            stop_loss_pips: slPips,
            take_profit_pips:tpPips,
          }
        );

        if (response.data) {
          let message = t('editSltp.orderUpdated')
          setTakeProfit(0.0);
          setStopLoss(0.0);
          toast.success(message, { position: "top-right" });
          setIsPositionEdited(Math.floor(Math.random()*100))
          onCancel();
        }
      }
    } catch (error) {
      const apiMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.response?.data?.data?.error ||
        t('editSltp.updateError');
      toast.error(apiMessage, { position: "top-right" });
      // Handle API request error
      console.error(
        `API request error: ${API_ENDPOINT_UPDATE_ORDER_DETAIL()}`,
        error
      );
    } finally {
      setIsLoading(false);
    }
  };
  //show spinner while loading data
  if (loadingSymbolContext) {
    return <Spinner />;
  }

  return (
    <div className="dialog-modal" onMouseMove={handleMouseMove} onMouseUp={handleMouseUp}>
      <div className="card draggable" style={{
          transform: `translate(${position.x}px, ${position.y}px)`,
          position: "absolute",
        }}>
        <div className="model-header" onMouseDown={handleMouseDown}>
          <h2>{t('editSltp.modifyOrder', { id: selectedPosition?.order_id })}</h2>
          <button
            onClick={() => {
              onCancel();
            }}
            className="close-icon"
          >
            <FaTimes />
          </button>
        </div>
        <div className="model-details">
          <p>{t('editSltp.symbol')}</p> <h2>{selectedPosition?.symbol}</h2>
          <p>{t('editSltp.currentPrice')}</p> <h2> {formatPrice(tradeEntryPrice)}</h2>
        </div>
        <div className="model-details model-details-entry">
          <p>{t('editSltp.entryPrice')}</p>
          <input
            type="text"
            inputMode="decimal"
            value={newEntryPrice ?? ""}
            maxLength={32}
            onChange={(e) => {
              const val = e.target.value;
              if (val.length > 32) return;
              // Allow empty / in-progress decimals like "0."; max 10 digits after decimal
              if (val === "" || /^\d*\.?\d{0,10}$/.test(val)) {
                entryPriceHandler(e);
              }
            }}
            onBlur={() => {
              const entry = parseFloat(newEntryPrice);
              if (newEntryPrice !== "" && newEntryPrice != null && !isNaN(entry) && entry > 0) {
                setNewEntryPrice(formatFixedTrimmed(entry, 10));
              }
            }}
          />
        </div>

        <div className="model-sltp-container">
          <PendingOrderSLTP
            isPendingOrder={true}
            isEditPosition={true}
            handleDisabledButton={handleDisabledButton}
            secondPrice={(direction == "Buy" ? selectedSymbol?.ask   : selectedSymbol?.bid)}
            positionDetails={currentPrice}
            handleSLPipsChange={handleSLPipsChange}
            handleTPPipsChange={handleTPPipsChange}
            handleProfitChange={handleProfitChange}
            handleLossChange={handleLossChange}
            direction={direction}
            quantity={tradeQuantity}
            entryPrice={newEntryPrice}
          />
        </div>

        <div className="row-scss">
          <button
            title={
              
                // (platFromData[5]?.riskLocked || platFromData[5]?.accessRight == 3)
                // ? "Trading for this Account in Disabled"
                // :platFromData[5]?.accessRight == 2
                //   ? "The status of this account is set to Close Only . You can only close your existing Positions" 
                //   : 
                  ""
            }   
          disabled={isFirstLoginDisabled || (platFromData[5]?.riskLocked || platFromData[5]?.accessRight == 3)|| localStorage.getItem('accountType') =="0"|| platFromData[5]?.accessRight == 2|| isLoading}
            onClick={() => {
              onSubmit();
            }}
          >
            {!isLoading ? t('editSltp.submit') : t('editSltp.loading')}
          </button>
          <button
            onClick={() => {
              onCancel();
            }}
          >
            {t('common.cancel')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditOrderSltp;
